import { render, staticRenderFns } from "./GerenciarBatidasRemotasPage.vue?vue&type=template&id=37e191e6&scoped=true"
import script from "./GerenciarBatidasRemotasPage.vue?vue&type=script&lang=js"
export * from "./GerenciarBatidasRemotasPage.vue?vue&type=script&lang=js"
import style0 from "./GerenciarBatidasRemotasPage.vue?vue&type=style&index=0&id=37e191e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e191e6",
  null
  
)

export default component.exports